import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getViewProfile,
  updateProfile,
} from "../../../redux/slices/profileSlice";

const LicenseNumberModal = ({
  show,
  onHide,
  value = "",
  shouldUpdateProfile = false,
  onSave,
  isApplyPage = false,
}) => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);

  const [licenseNumber, setLicenseNumber] = useState("");
  const [error, setError] = useState("");

  // Load existing value
  // useEffect(() => {
  //   if (!show) return;

  //   const current = store?.profileItem?.data?.nurseProfile?.license_number;

  //   if (current) {
  //     setLicenseNumber(current);
  //   }
  // }, [show, store?.profileItem]);
  useEffect(() => {
    if (!show) return;

    if (isApplyPage) {
      setLicenseNumber(value || "");
    } else {
      const current = store?.profileItem?.data?.nurseProfile?.license_number;

      if (current) {
        setLicenseNumber(current);
      }
    }
  }, [show, value, isApplyPage]);
  const handleSave = () => {
    const trimmed = licenseNumber.trim();

    if (!trimmed) {
      setError("License number is required");
      return;
    }

    if (trimmed.length > 100) {
      setError("License number must be less than 100 characters");
      return;
    }

    if (isApplyPage) {
      // ✅ always update local form
      onSave(trimmed);

      // 🔥 ONLY call API if empty before
      if (shouldUpdateProfile) {
        const formData = new FormData();

        formData.append(
          "name",
          store?.profileItem?.data?.name ||
            store?.profileItem?.data?.full_name ||
            "",
        );

        formData.append("license_number", trimmed);

        dispatch(updateProfile(formData));
      }

      onHide();
    } else {
      // ✅ Profile page → always API
      const formData = new FormData();

      formData.append(
        "name",
        store?.profileItem?.data?.name ||
          store?.profileItem?.data?.full_name ||
          "",
      );

      formData.append("license_number", trimmed);

      dispatch(updateProfile(formData));
    }
  };
  // const handleSave = () => {
  //   const trimmed = licenseNumber.trim();

  //   if (!trimmed) {
  //     setError("License number is required");
  //     return;
  //   }

  //   if (trimmed.length > 100) {
  //     setError("License number must be less than 100 characters");
  //     return;
  //   }

  //   if (isApplyPage) {
  //     onSave(trimmed);
  //     onHide();
  //   } else {
  //     const formData = new FormData();

  //     formData.append(
  //       "name",
  //       store?.profileItem?.data?.name ||
  //         store?.profileItem?.data?.full_name ||
  //         "",
  //     );

  //     formData.append("license_number", trimmed);

  //     dispatch(updateProfile(formData));
  //   }
  // };
  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
    }
  }, [store?.actionFlag]);
  useEffect(() => {
    if (show) {
      // dispatch(getViewProfile());
    }
  }, [show, dispatch]);
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="md"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">Enter Nursing License Number</h5>

        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div className="form-group">
          <label className="col-label">Nursing License Number</label>

          <Form.Control
            type="text"
            placeholder="RN123456789"
            value={licenseNumber}
            maxLength={100}
            onChange={(e) => {
              setLicenseNumber(e.target.value);
              setError("");
            }}
            className={`col-input ${error ? "is-invalid" : ""}`}
          />
        </div>

        {error && <div className="error-message mt-2">{error}</div>}

        <div className="text-center mt-4">
          <Button
            className="btn-primary px-4"
            onClick={handleSave}
            disabled={store?.isLoading || !licenseNumber.trim()}
          >
            {store?.isLoading ? "Saving..." : "Save"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LicenseNumberModal;
